export const LOGIN_DIALOG_CONTENT = {
	registerKey: "register.create-account",
	loginKey: "general.sign-in",
	dgaRegisterKey: "register.title",
	registerDescriptionKey: "register.description",
};
